<template>
  <el-form
    :model="rule"
    :rules="rules"
    ref="forms"
    class="demo-ruleForm"
    label-width="100px"
  >
    <el-form-item label="整机型号" prop="termId">
      <el-select v-model="rule.termId" placeholder="请选择">
        <el-option value="" label="请选择"></el-option>
        <el-option
          v-for="x in selectList"
          :key="x.id"
          :value="x.id"
          :label="x.name"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="数量" prop="devNum">
      <el-input
        type="number"
        placeholder="请输入数量"
        v-model="rule.devNum"
        clearable
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">提交</el-button>
      <el-button @click="block">返回</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  data() {
    return {
      name: "edit",
      rule: {
        termId: "",
        devNum: null,
      },
      rules: {
        termId: [{ required: true, message: "请选择设备型号" }],
        devNum: [{ required: true, message: "请输入数量", trigger: "blur" }],
      },
      selectList: [],
    };
  },
  beforeCreate() {
    this.$http
      .post("/manage/machine/page", {
        pageNum: 1,
        pageSize: 9999,
        kind: "portable",
      })
      .then((data) => {
        this.selectList = data["data"]["data"]["records"].map((i) => {
          return {
            name: `${i.model}`,
            id: i.model,
          };
        });
      });
  },
  methods: {
    submit() {
      this.$refs["forms"].validate((valid) => {
        if (valid) {
          this.rule.devNum = Number(this.rule.devNum);
          this.$http.post("/manage/dev/add", this.rule).then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$router.push("/equipment/portable/equi/index");
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
        }
      });
    },
    block() {
      this.$router.push("/equipment/portable/equi/index");
    },
    change() {
      //潜入太深，需要刷新
      this.$forceUpdate();
    },
  },
};
</script>
